(ns common.db.coeffects.localstorage
  (:require [clojure.spec.alpha :as spec]
            [common.localstorage :as localstorage]
            [re-frame.core :as rf]))

(defn localstorage
  "Read from local storage

   Example:

   ```clojure
   (rf/reg-event-fx :sample-event
    [(rf/inject-cofx :localstorage \"something-stored-in-ls\")]
    (fn [{:keys [localstorage]}]
      ...))

   (rf/reg-event-fx :sample-event
    [(rf/inject-cofx :localstorage [\"something-stored-in-ls\" \"other-stored-in-ls\"] )]
    (fn [{:keys [localstorage]}]
      ...))
   ```"
  [cofx ks]
  {:pre [(spec/assert (spec/or :set set? :seq sequential? :string string?) ks)]}
  (reduce (fn [cofx* k]
            (assoc cofx* (keyword :localstorage k) (localstorage/get k)))
          cofx
          (if ((some-fn sequential? set?) ks) ks [ks])))

(rf/reg-cofx :localstorage localstorage)
